import { render, staticRenderFns } from "./FlightPriceDetails.vue?vue&type=template&id=5e08df0b"
import script from "./FlightPriceDetails.vue?vue&type=script&lang=js"
export * from "./FlightPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./FlightPriceDetails.vue?vue&type=style&index=0&id=5e08df0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports